module.exports = __webpack_public_path__ + "static/img/infoimg.6b75c4a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/infoimg.jpg
// module id = kuXa
// module chunks = 1